var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTagsFilterModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1473 9.43053C13.2252 9.43053 14.0832 10.2865 14.0832 11.3244C14.0832 12.3616 13.2253 13.2176 12.1473 13.2176C11.07 13.2176 10.2114 12.3615 10.2114 11.3244C10.2114 10.2866 11.0701 9.43053 12.1473 9.43053ZM6.14217 10.8035C6.46389 10.8035 6.71017 11.0581 6.71017 11.3528C6.71017 11.647 6.46365 11.9021 6.14217 11.9021H1.48451C1.16303 11.9021 0.916504 11.647 0.916504 11.3528C0.916504 11.0581 1.16279 10.8035 1.48451 10.8035H6.14217ZM2.85237 1.625C3.93032 1.625 4.78824 2.48104 4.78824 3.51815C4.78824 4.55613 3.93022 5.41207 2.85237 5.41207C1.7752 5.41207 0.916504 4.55603 0.916504 3.51815C0.916504 2.48114 1.7751 1.625 2.85237 1.625ZM13.516 2.96965C13.8369 2.96965 14.0832 3.22422 14.0832 3.51815C14.0832 3.81309 13.8366 4.06742 13.516 4.06742H8.8583C8.53657 4.06742 8.29029 3.81285 8.29029 3.51815C8.29029 3.22445 8.53633 2.96965 8.8583 2.96965H13.516Z",
    stroke: "#C4C4C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagsFilterModal);
export default __webpack_public_path__ + "static/media/tags-filter-modal.5e81d625b4da8aa433de35ce53ddfb26.svg";
export { ForwardRef as ReactComponent };